import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Button,
  Input
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardBillingPaymentArUX = (props: any) => {
    return(
      <div
        id="CardBillingPaymentArUX-div-0"
        style={{ width: "100%", padding: "10px" }}>
        <div
          id="CardBillingPaymentArUX-div-24"
          style={{fontWeight: "bold", fontSize: "1.2rem", display: "flex", justifyContent: "space-between", }}>
          {props.languageUX === "en" ? "Record Payment from Affiliated Dept." : "บันทึกรับชำระเงินจากหน่วยงานต้นสังกัด"}
        </div>
        <div
          id="CardBillingPaymentArUX-div-128">
          
          <hr
            id="CardBillingPaymentArUX-hr-129">
          </hr>
        </div>
        <Form
          id="CardBillingPaymentArUX-Form-226">
          <FormGroup
            id="CardBillingPaymentArUX-FormGroup-227"
            inline={true}
            style={{ display: "flex", alignItems: "center" }}>
            <FormField
              id="CardBillingPaymentArUX-FormField-230"
              inline={true}
              width={7}>
              <div
                id="CardBillingPaymentArUX-div-241"
                style={{ display: "flex", width: "100%", alignItems: "center" }}>
                
                <div
                  id="CardBillingPaymentArUX-div-248"
                  style={{ display: "flex", marginRight: "10px", width: "65%" }}>
                  
                  <div
                    id="CardBillingPaymentArUX-div-252"
                    style={{ fontWeight: "bold" }}>
                    {props.languageUX === "en" ? "Invoice number from Affiliated Dept." : "เลขที่ใบแจ้งหนี้เรียกเก็บเงินจากต้นสังกัด"}
                  </div>
                  <div
                    id="CardBillingPaymentArUX-div-253"
                    style={{ color: "red" }}>
                    *
                  </div>
                </div>
                <div
                  id="CardBillingPaymentArUX-div-254"
                  style={{ width: "100%", }}>
                  {props.arTransaction}
                </div>
              </div>
            </FormField>
            <FormField
              id="CardBillingPaymentArUX-FormField-231"
              inline={true}
              width={4}>
              <div
                id="CardBillingPaymentArUX-div-240"
                style={{ display: "flex", width: "100%", alignItems: "center" }}>
                
                <div
                  id="CardBillingPaymentArUX-div-246"
                  style={{ fontWeight: "bold", marginRight: "10px", width: "20%" }}>
                  {props.languageUX === "en" ? "Coverage" : "สิทธิ"}
                </div>
                <div
                  id="CardBillingPaymentArUX-div-255"
                  style={{ background: "#F1F1F1", padding: "6px 15px", borderRadius: 4, width: "100%", marginRight: "20px" }}>
                  {props.selectPaymentAr?.coverage_code_name ||  "-"}
                </div>
              </div>
            </FormField>
            <FormField
              id="CardBillingPaymentArUX-FormField-232"
              inline={true}
              width={5}>
              <div
                id="CardBillingPaymentArUX-div-239"
                style={{ display: "flex", width: "100%", alignItems: "center" }}>
                
                <div
                  id="CardBillingPaymentArUX-div-247"
                  style={{ fontWeight: "bold", marginRight: "10px", width: "55%" }}>
                  {props.languageUX === "en" ? "Billing Affiliated Dept." : "หน่วยงานต้นสังกัดที่เรียกเก็บ"}
                </div>
                <div
                  id="CardBillingPaymentArUX-div-256"
                  style={{ background: "#F1F1F1", padding: "6px 15px", borderRadius: 4, width: "100%", marginRight: "20px" }}>
                  {props.selectPaymentAr?.payer_code_name ||  "-"}
                </div>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardBillingPaymentArUX-FormGroup-228"
            inline={true}
            style={{ display: "flex", alignItems: "center" }}>
            <FormField
              id="CardBillingPaymentArUX-FormField-233"
              inline={true}
              width={6}>
              <div
                id="CardBillingPaymentArUX-div-257"
                style={{ display: "flex", width: "100%", alignItems: "center" }}>
                
                <div
                  id="CardBillingPaymentArUX-div-263"
                  style={{ fontWeight: "bold", marginRight: "10px", width: "55%" }}>
                  {props.languageUX === "en" ? "Invoiced by" : "ออกใบแจ้งหนี้โดย"}
                </div>
                <div
                  id="CardBillingPaymentArUX-div-265"
                  style={{ background: "#F1F1F1", padding: "6px 15px", borderRadius: 4, width: "100%", marginRight: "20px" }}>
                  {props.selectPaymentAr?.created_user_name ||  "-"}
                </div>
              </div>
            </FormField>
            <FormField
              id="CardBillingPaymentArUX-FormField-234"
              inline={true}
              width={5}>
              <div
                id="CardBillingPaymentArUX-div-258"
                style={{ display: "flex", width: "100%", alignItems: "center" }}>
                
                <div
                  id="CardBillingPaymentArUX-div-264"
                  style={{ fontWeight: "bold", marginRight: "10px", width: "55%" }}>
                  {props.languageUX === "en" ? "Invoice Date" : "วันที่ออกใบแจ้งหนี้"}
                </div>
                <div
                  id="CardBillingPaymentArUX-div-266"
                  style={{ background: "#F1F1F1", padding: "6px 15px", borderRadius: 4, width: "100%", marginRight: "20px" }}>
                  {props.selectPaymentAr?.created_at ||  "-"}
                </div>
              </div>
            </FormField>
            <FormField
              id="CardBillingPaymentArUX-FormField-235"
              inline={true}
              width={5}>
              <div
                id="CardBillingPaymentArUX-div-259"
                style={{ display: "flex", width: "100%", alignItems: "center" }}>
                
                <div
                  id="CardBillingPaymentArUX-div-267"
                  style={{ fontWeight: "bold", marginRight: "10px", width: "55%" }}>
                  {props.languageUX === "en" ? "Invoice Status" : "สถานะใบแจ้งหนี้"}
                </div>
                <div
                  id="CardBillingPaymentArUX-div-268"
                  style={{ background: "#F1F1F1", padding: "6px 15px", borderRadius: 4, width: "100%", marginRight: "20px" }}>
                  {props.selectPaymentAr?.sent_claim_status_display ||  "-"}
                </div>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardBillingPaymentArUX-FormGroup-229"
            inline={true}
            style={{ display: "flex", alignItems: "center" }}>
            <FormField
              id="CardBillingPaymentArUX-FormField-236"
              inline={true}
              width={6}>
              <div
                id="CardBillingPaymentArUX-div-260"
                style={{ display: "flex", width: "100%", alignItems: "center" }}>
                
                <div
                  id="CardBillingPaymentArUX-div-269"
                  style={{ fontWeight: "bold", marginRight: "10px", width: "55%" }}>
                  {props.languageUX === "en" ? "Number of Claimable Items" : "จำนวนข้อมูลที่เบิกได้"}
                </div>
                <div
                  id="CardBillingPaymentArUX-div-270"
                  style={{ background: "#F1F1F1", padding: "6px 15px", borderRadius: 4, width: "100%", marginRight: "20px" }}>
                  {props.invoiceArItem?.total_claim_count || "-"}
                </div>
              </div>
            </FormField>
            <FormField
              id="CardBillingPaymentArUX-FormField-237"
              inline={true}
              width={5}>
              <div
                id="CardBillingPaymentArUX-div-261"
                style={{ display: "flex", width: "100%", alignItems: "center" }}>
                
                <div
                  id="CardBillingPaymentArUX-div-271"
                  style={{ fontWeight: "bold", marginRight: "10px", width: "55%" }}>
                  {props.languageUX === "en" ? "Claim Amount (Baht" : "ยอดเบิก (บาท)"}
                </div>
                <div
                  id="CardBillingPaymentArUX-div-272"
                  style={{ background: "#F1F1F1", padding: "6px 15px", borderRadius: 4, width: "100%", marginRight: "20px" }}>
                  {props.totalSendClaimPrice || "-"}
                </div>
              </div>
            </FormField>
            <FormField
              id="CardBillingPaymentArUX-FormField-238"
              inline={true}
              width={5}>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardBillingPaymentArUX-div-302">
          {props.paymentStatue}
        </div>
        <div
          id="CardBillingPaymentArUX-div-274"
          style={{ padding: "10px 0px", ...(props.orderBy !== "Mode" && { display: "none" }) }}>
          
          <Table
            data={props.arModeData}
            headers=",รหัส,หมวดค่าใช้จ่าย,ส่งเบิก,รับชำระ"
            id="CardBillingPaymentArUX-Table-276"
            keys="chk,bill_mode_code,bill_mode_name,total_send_claim_price,total_pay_price"
            minRows={10}
            showPagination={false}
            style={{ height: "550px" }}
            widths="^15,^30,^150,^60,^60">
          </Table>
        </div>
        <div
          id="CardBillingPaymentArUX-div-298"
          style={{ padding: "10px 0px", ...(props.orderBy !== "Item" && { display: "none" }) }}>
          
          <Table
            data={props.arItemData}
            headers=",รหัส,ชื่อรายการ,หมวดค่าใช้จ่าย,จำนวน,ส่งเบิก,รับชำระ,ค้างชำระ"
            id="CardBillingPaymentArUX-Table-300"
            keys="chk,product_code,product_name,bill_mode_name,quantity,total_send_claim_price,total_pay_price,unpaidValue"
            minRows="10"
            showPagination={false}
            style={{ height: "550px" }}
            widths="^30,^40,^140,^140,^60,^60,^80,^60">
          </Table>
        </div>
        <div
          id="CardBillingPaymentArUX-div-275"
          style={{ display: "flex" }}>
          
          <div
            id="CardBillingPaymentArUX-div-277"
            style={{ display: "flex" }}>
            
            <Button
              className={props.orderBy === "Mode" && "active"}
              color="teal"
              id="btn-billMode"
              name="Mode"
              onClick={props.onChangeOrderBy}
              size="mini">
              {props.languageUX === "en" ? "BY MODE" : "หมวดสินค้า/บริการ"}
            </Button>
            <Button
              className={props.orderBy === "Item" && "active"}
              color="teal"
              id="btn-billItem"
              name="Item"
              onClick={props.onChangeOrderBy}
              size="mini">
              {props.languageUX === "en" ? "BY ITEM" : "รายการสินค้า/บริการ"}
            </Button>
          </div>
          <div
            id="CardBillingPaymentArUX-div-299"
            style={{ margin: "0px 50px" }}>
            
          </div>
          <div
            id="CardBillingPaymentArUX-div-278"
            style={{  display: "flex", justifyContent: "center", alignItems: "center" }}>
            
            <div
              id="CardBillingPaymentArUX-div-282"
              style={{ marginRight: "10px" }}>
              {props.languageUX === "en" ? "Select:" : "เลือก:"}
            </div>
            <Button
              id="btn-billAll"
              onClick={props.onClickAll}
              size="mini">
              {props.languageUX === "en" ? "All" : "ทั้งหมด"}
            </Button>
            <Button
              id="btn-billNone"
              onClick={props.onClickNone}
              size="mini"
              style={{ marginLeft: "10px" }}>
              {props.languageUX === "en" ? "None" : "ไม่มี"}
            </Button>
          </div>
          <div
            id="CardBillingPaymentArUX-div-294"
            style={{ flex: 1 }}>
            
          </div>
          <div
            id="CardBillingPaymentArUX-div-281"
            style={{ display: "flex" }}>
            
            <div
              id="CardBillingPaymentArUX-div-285"
              style={{ display: "flex", width: "100%", alignItems: "center" }}>
              
              <div
                id="CardBillingPaymentArUX-div-288"
                style={{ margin: "0px 10px", width: "55%" }}>
                {props.languageUX === "en" ? "Claim submit" : "ส่งเบิก"}
              </div>
              <Input
                className={props.classes.inputSummary}
                id="CardBillingPaymentArUX-Input-291"
                readOnly="true"
                size="mini"
                style={{ width: "62%" }}
                value={props.invoiceTotalSendClaimPrice}>
              </Input>
            </div>
            <div
              id="CardBillingPaymentArUX-div-286"
              style={{ display: "flex", width: "100%", alignItems: "center" }}>
              
              <div
                id="CardBillingPaymentArUX-div-289"
                style={{ margin: "0px 10px", width: "55%" }}>
                {props.languageUX === "en" ? "Payment Received" : "รับชำระ"}
              </div>
              <Input
                className={props.classes.inputSummary}
                id="CardBillingPaymentArUX-Input-292"
                readOnly="true"
                size="mini"
                style={{ width: "62%" }}
                value={props.invoiceTotalRemainPrice}>
              </Input>
            </div>
            <div
              id="CardBillingPaymentArUX-div-287"
              style={{ display: "none", ...(props.orderBy === "Item" && { display: "flex", width: "100%", alignItems: "center"  })}}>
              
              <div
                id="CardBillingPaymentArUX-div-290"
                style={{ margin: "0px 10px", width: "55%" }}>
                {props.languageUX === "en" ? "Overdue" : "ค้างชำระ"}
              </div>
              <Input
                className={Number(props.invoiceSummary?.total_paid_price) !== 0 ? props.classes.inputColorRed : props.classes.inputSummary}
                id="CardBillingPaymentArUX-Input-293"
                readOnly="true"
                size="mini"
                style={{ width: "62%",  }}
                value={props.invoiceTotalPaidPrice}>
              </Input>
            </div>
          </div>
        </div>
        <div
          id="CardBillingPaymentArUX-div-295"
          style={{ display: "flex", justifyContent: "flex-end", padding: "15px 0px" }}>
          
          <div
            id="CardBillingPaymentArUX-div-301"
            style={{ margin: "0px 10px" }}>
            {props.buttonPrint}
          </div>
          <Button
            color="green"
            disabled={props.disabledPayment}
            id="btn-billPayment"
            onClick={props.billPayment}>
            {props.languageUX === "en" ? "Payment Received" : "รับชำระเงิน"}
          </Button>
        </div>
      </div>
    )
}


export default CardBillingPaymentArUX

export const screenPropsDefault = {"debug":true,"language":"EN","showSupplyList":false}

/* Date Time : Fri Oct 31 2025 04:20:16 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", padding: \"10px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึกรับชำระเงินจากหน่วยงานต้นสังกัด",
          "valueEN": "Record Payment from Affiliated Dept."
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\", display: \"flex\", justifyContent: \"space-between\", }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-128"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "hr",
      "parent": 128,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-hr-129"
        }
      },
      "seq": 129,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 226,
      "name": "Form",
      "parent": 0,
      "props": {
        "className": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-Form-226"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 227,
      "name": "FormGroup",
      "parent": 226,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-FormGroup-227"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 227,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 228,
      "name": "FormGroup",
      "parent": 226,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-FormGroup-228"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 228,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 229,
      "name": "FormGroup",
      "parent": 226,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-FormGroup-229"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 229,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 230,
      "name": "FormField",
      "parent": 227,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-FormField-230"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 230,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 231,
      "name": "FormField",
      "parent": 227,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-FormField-231"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 231,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 232,
      "name": "FormField",
      "parent": 227,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-FormField-232"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 232,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 233,
      "name": "FormField",
      "parent": 228,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-FormField-233"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 233,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 234,
      "name": "FormField",
      "parent": 228,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-FormField-234"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 234,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 235,
      "name": "FormField",
      "parent": 228,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-FormField-235"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 235,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 236,
      "name": "FormField",
      "parent": 229,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-FormField-236"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 236,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 237,
      "name": "FormField",
      "parent": 229,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-FormField-237"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 237,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 238,
      "name": "FormField",
      "parent": 229,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-FormField-238"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 238,
      "void": false
    },
    {
      "from": null,
      "id": 239,
      "name": "div",
      "parent": 232,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-239"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", alignItems: \"center\" }"
        }
      },
      "seq": 239,
      "void": false
    },
    {
      "from": null,
      "id": 240,
      "name": "div",
      "parent": 231,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-240"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", alignItems: \"center\" }"
        }
      },
      "seq": 240,
      "void": false
    },
    {
      "from": null,
      "id": 241,
      "name": "div",
      "parent": 230,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-241"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", alignItems: \"center\" }"
        }
      },
      "seq": 241,
      "void": false
    },
    {
      "from": null,
      "id": 246,
      "name": "div",
      "parent": 240,
      "props": {
        "children": {
          "type": "value",
          "value": "สิทธิ",
          "valueEN": "Coverage"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-246"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", marginRight: \"10px\", width: \"20%\" }"
        }
      },
      "seq": 246,
      "void": false
    },
    {
      "from": null,
      "id": 247,
      "name": "div",
      "parent": 239,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วยงานต้นสังกัดที่เรียกเก็บ",
          "valueEN": "Billing Affiliated Dept."
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-247"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", marginRight: \"10px\", width: \"55%\" }"
        }
      },
      "seq": 247,
      "void": false
    },
    {
      "from": null,
      "id": 248,
      "name": "div",
      "parent": 241,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-248"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", marginRight: \"10px\", width: \"65%\" }"
        }
      },
      "seq": 245,
      "void": false
    },
    {
      "from": null,
      "id": 252,
      "name": "div",
      "parent": 248,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่ใบแจ้งหนี้เรียกเก็บเงินจากต้นสังกัด",
          "valueEN": "Invoice number from Affiliated Dept."
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-252"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 252,
      "void": false
    },
    {
      "from": null,
      "id": 253,
      "name": "div",
      "parent": 248,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-253"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 253,
      "void": false
    },
    {
      "from": null,
      "id": 254,
      "name": "div",
      "parent": 241,
      "props": {
        "children": {
          "type": "code",
          "value": "props.arTransaction"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-254"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", }"
        }
      },
      "seq": 254,
      "void": false
    },
    {
      "from": null,
      "id": 255,
      "name": "div",
      "parent": 240,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectPaymentAr?.coverage_code_name ||  \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-255"
        },
        "style": {
          "type": "code",
          "value": "{ background: \"#F1F1F1\", padding: \"6px 15px\", borderRadius: 4, width: \"100%\", marginRight: \"20px\" }"
        }
      },
      "seq": 255,
      "void": false
    },
    {
      "from": null,
      "id": 256,
      "name": "div",
      "parent": 239,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectPaymentAr?.payer_code_name ||  \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-256"
        },
        "style": {
          "type": "code",
          "value": "{ background: \"#F1F1F1\", padding: \"6px 15px\", borderRadius: 4, width: \"100%\", marginRight: \"20px\" }"
        }
      },
      "seq": 256,
      "void": false
    },
    {
      "from": null,
      "id": 257,
      "name": "div",
      "parent": 233,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-257"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", alignItems: \"center\" }"
        }
      },
      "seq": 257,
      "void": false
    },
    {
      "from": null,
      "id": 258,
      "name": "div",
      "parent": 234,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-258"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", alignItems: \"center\" }"
        }
      },
      "seq": 258,
      "void": false
    },
    {
      "from": null,
      "id": 259,
      "name": "div",
      "parent": 235,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-259"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", alignItems: \"center\" }"
        }
      },
      "seq": 259,
      "void": false
    },
    {
      "from": null,
      "id": 260,
      "name": "div",
      "parent": 236,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-260"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", alignItems: \"center\" }"
        }
      },
      "seq": 260,
      "void": false
    },
    {
      "from": null,
      "id": 261,
      "name": "div",
      "parent": 237,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-261"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", alignItems: \"center\" }"
        }
      },
      "seq": 261,
      "void": false
    },
    {
      "from": null,
      "id": 263,
      "name": "div",
      "parent": 257,
      "props": {
        "children": {
          "type": "value",
          "value": "ออกใบแจ้งหนี้โดย",
          "valueEN": "Invoiced by"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-263"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", marginRight: \"10px\", width: \"55%\" }"
        }
      },
      "seq": 263,
      "void": false
    },
    {
      "from": null,
      "id": 264,
      "name": "div",
      "parent": 258,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ออกใบแจ้งหนี้",
          "valueEN": "Invoice Date"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-264"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", marginRight: \"10px\", width: \"55%\" }"
        }
      },
      "seq": 264,
      "void": false
    },
    {
      "from": null,
      "id": 265,
      "name": "div",
      "parent": 257,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectPaymentAr?.created_user_name ||  \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-265"
        },
        "style": {
          "type": "code",
          "value": "{ background: \"#F1F1F1\", padding: \"6px 15px\", borderRadius: 4, width: \"100%\", marginRight: \"20px\" }"
        }
      },
      "seq": 265,
      "void": false
    },
    {
      "from": null,
      "id": 266,
      "name": "div",
      "parent": 258,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectPaymentAr?.created_at ||  \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-266"
        },
        "style": {
          "type": "code",
          "value": "{ background: \"#F1F1F1\", padding: \"6px 15px\", borderRadius: 4, width: \"100%\", marginRight: \"20px\" }"
        }
      },
      "seq": 266,
      "void": false
    },
    {
      "from": null,
      "id": 267,
      "name": "div",
      "parent": 259,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะใบแจ้งหนี้",
          "valueEN": "Invoice Status"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-267"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", marginRight: \"10px\", width: \"55%\" }"
        }
      },
      "seq": 267,
      "void": false
    },
    {
      "from": null,
      "id": 268,
      "name": "div",
      "parent": 259,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectPaymentAr?.sent_claim_status_display ||  \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-268"
        },
        "style": {
          "type": "code",
          "value": "{ background: \"#F1F1F1\", padding: \"6px 15px\", borderRadius: 4, width: \"100%\", marginRight: \"20px\" }"
        }
      },
      "seq": 268,
      "void": false
    },
    {
      "from": null,
      "id": 269,
      "name": "div",
      "parent": 260,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวนข้อมูลที่เบิกได้",
          "valueEN": "Number of Claimable Items"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-269"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", marginRight: \"10px\", width: \"55%\" }"
        }
      },
      "seq": 269,
      "void": false
    },
    {
      "from": null,
      "id": 270,
      "name": "div",
      "parent": 260,
      "props": {
        "children": {
          "type": "code",
          "value": "props.invoiceArItem?.total_claim_count || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-270"
        },
        "style": {
          "type": "code",
          "value": "{ background: \"#F1F1F1\", padding: \"6px 15px\", borderRadius: 4, width: \"100%\", marginRight: \"20px\" }"
        }
      },
      "seq": 270,
      "void": false
    },
    {
      "from": null,
      "id": 271,
      "name": "div",
      "parent": 261,
      "props": {
        "children": {
          "type": "value",
          "value": "ยอดเบิก (บาท)",
          "valueEN": "Claim Amount (Baht"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-271"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", marginRight: \"10px\", width: \"55%\" }"
        }
      },
      "seq": 271,
      "void": false
    },
    {
      "from": null,
      "id": 272,
      "name": "div",
      "parent": 261,
      "props": {
        "children": {
          "type": "code",
          "value": "props.totalSendClaimPrice || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-272"
        },
        "style": {
          "type": "code",
          "value": "{ background: \"#F1F1F1\", padding: \"6px 15px\", borderRadius: 4, width: \"100%\", marginRight: \"20px\" }"
        }
      },
      "seq": 272,
      "void": false
    },
    {
      "from": null,
      "id": 274,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-274"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px 0px\", ...(props.orderBy !== \"Mode\" && { display: \"none\" }) }"
        }
      },
      "seq": 275,
      "void": false
    },
    {
      "from": null,
      "id": 275,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-275"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 299,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 276,
      "name": "Table",
      "parent": 274,
      "props": {
        "data": {
          "type": "code",
          "value": "props.arModeData"
        },
        "defaultPageSize": {
          "type": "value",
          "value": ""
        },
        "headers": {
          "type": "value",
          "value": ",รหัส,หมวดค่าใช้จ่าย,ส่งเบิก,รับชำระ"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-Table-276"
        },
        "keys": {
          "type": "value",
          "value": "chk,bill_mode_code,bill_mode_name,total_send_claim_price,total_pay_price"
        },
        "minRows": {
          "type": "code",
          "value": "10"
        },
        "pageSize": {
          "type": "value",
          "value": ""
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"550px\" }"
        },
        "widths": {
          "type": "value",
          "value": "^15,^30,^150,^60,^60"
        }
      },
      "seq": 276,
      "void": false
    },
    {
      "from": null,
      "id": 277,
      "name": "div",
      "parent": 275,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-277"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 277,
      "void": false
    },
    {
      "from": null,
      "id": 278,
      "name": "div",
      "parent": 275,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-278"
        },
        "style": {
          "type": "code",
          "value": "{  display: \"flex\", justifyContent: \"center\", alignItems: \"center\" }"
        }
      },
      "seq": 281,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 279,
      "name": "Button",
      "parent": 277,
      "props": {
        "children": {
          "type": "value",
          "value": "หมวดสินค้า/บริการ",
          "valueEN": "BY MODE"
        },
        "className": {
          "type": "code",
          "value": "props.orderBy === \"Mode\" && \"active\""
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "btn-billMode"
        },
        "name": {
          "type": "value",
          "value": "Mode"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeOrderBy"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 279,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 280,
      "name": "Button",
      "parent": 277,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการสินค้า/บริการ",
          "valueEN": "BY ITEM"
        },
        "className": {
          "type": "code",
          "value": "props.orderBy === \"Item\" && \"active\""
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "btn-billItem"
        },
        "name": {
          "type": "value",
          "value": "Item"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeOrderBy"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 280,
      "void": false
    },
    {
      "from": null,
      "id": 281,
      "name": "div",
      "parent": 275,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-281"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 299,
      "void": false
    },
    {
      "from": null,
      "id": 282,
      "name": "div",
      "parent": 278,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือก:",
          "valueEN": "Select:"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-282"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        }
      },
      "seq": 282,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 283,
      "name": "Button",
      "parent": 278,
      "props": {
        "children": {
          "type": "value",
          "value": "ทั้งหมด",
          "valueEN": "All"
        },
        "id": {
          "type": "value",
          "value": "btn-billAll"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickAll"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 283,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 284,
      "name": "Button",
      "parent": 278,
      "props": {
        "children": {
          "type": "value",
          "value": "ไม่มี",
          "valueEN": "None"
        },
        "id": {
          "type": "value",
          "value": "btn-billNone"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickNone"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"10px\" }"
        }
      },
      "seq": 284,
      "void": false
    },
    {
      "from": null,
      "id": 285,
      "name": "div",
      "parent": 281,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-285"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", alignItems: \"center\" }"
        }
      },
      "seq": 285,
      "void": false
    },
    {
      "from": null,
      "id": 286,
      "name": "div",
      "parent": 281,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-286"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"100%\", alignItems: \"center\" }"
        }
      },
      "seq": 286,
      "void": false
    },
    {
      "from": null,
      "id": 287,
      "name": "div",
      "parent": 281,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-287"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"none\", ...(props.orderBy === \"Item\" && { display: \"flex\", width: \"100%\", alignItems: \"center\"  })}"
        }
      },
      "seq": 287,
      "void": false
    },
    {
      "from": null,
      "id": 288,
      "name": "div",
      "parent": 285,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่งเบิก",
          "valueEN": "Claim submit"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-288"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\", width: \"55%\" }"
        }
      },
      "seq": 288,
      "void": false
    },
    {
      "from": null,
      "id": 289,
      "name": "div",
      "parent": 286,
      "props": {
        "children": {
          "type": "value",
          "value": "รับชำระ",
          "valueEN": "Payment Received"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-289"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\", width: \"55%\" }"
        }
      },
      "seq": 289,
      "void": false
    },
    {
      "from": null,
      "id": 290,
      "name": "div",
      "parent": 287,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้างชำระ",
          "valueEN": "Overdue"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-290"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\", width: \"55%\" }"
        }
      },
      "seq": 290,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 291,
      "name": "Input",
      "parent": 285,
      "props": {
        "className": {
          "type": "code",
          "value": "props.classes.inputSummary"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-Input-291"
        },
        "readOnly": {
          "type": "value",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"62%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceTotalSendClaimPrice"
        }
      },
      "seq": 291,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 292,
      "name": "Input",
      "parent": 286,
      "props": {
        "className": {
          "type": "code",
          "value": "props.classes.inputSummary"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-Input-292"
        },
        "readOnly": {
          "type": "value",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"62%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceTotalRemainPrice"
        }
      },
      "seq": 292,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 293,
      "name": "Input",
      "parent": 287,
      "props": {
        "className": {
          "type": "code",
          "value": "Number(props.invoiceSummary?.total_paid_price) !== 0 ? props.classes.inputColorRed : props.classes.inputSummary"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-Input-293"
        },
        "readOnly": {
          "type": "value",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"62%\",  }"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceTotalPaidPrice"
        }
      },
      "seq": 293,
      "void": false
    },
    {
      "from": null,
      "id": 294,
      "name": "div",
      "parent": 275,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-294"
        },
        "style": {
          "type": "code",
          "value": "{ flex: 1 }"
        }
      },
      "seq": 294,
      "void": false
    },
    {
      "from": null,
      "id": 295,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-295"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\", padding: \"15px 0px\" }"
        }
      },
      "seq": 302,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 297,
      "name": "Button",
      "parent": 295,
      "props": {
        "children": {
          "type": "value",
          "value": "รับชำระเงิน",
          "valueEN": "Payment Received"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledPayment"
        },
        "id": {
          "type": "value",
          "value": "btn-billPayment"
        },
        "onClick": {
          "type": "code",
          "value": "props.billPayment"
        }
      },
      "seq": 301,
      "void": false
    },
    {
      "from": null,
      "id": 298,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-298"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px 0px\", ...(props.orderBy !== \"Item\" && { display: \"none\" }) }"
        }
      },
      "seq": 298,
      "void": false
    },
    {
      "from": null,
      "id": 299,
      "name": "div",
      "parent": 275,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-299"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 50px\" }"
        }
      },
      "seq": 278,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 300,
      "name": "Table",
      "parent": 298,
      "props": {
        "data": {
          "type": "code",
          "value": "props.arItemData"
        },
        "defaultPageSize": {
          "type": "value",
          "value": ""
        },
        "headers": {
          "type": "value",
          "value": ",รหัส,ชื่อรายการ,หมวดค่าใช้จ่าย,จำนวน,ส่งเบิก,รับชำระ,ค้างชำระ"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-Table-300"
        },
        "keys": {
          "type": "value",
          "value": "chk,product_code,product_name,bill_mode_name,quantity,total_send_claim_price,total_pay_price,unpaidValue"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "pageSize": {
          "type": "value",
          "value": ""
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"550px\" }"
        },
        "widths": {
          "type": "value",
          "value": "^30,^40,^140,^140,^60,^60,^80,^60"
        }
      },
      "seq": 300,
      "void": false
    },
    {
      "from": null,
      "id": 301,
      "name": "div",
      "parent": 295,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrint"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-301"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        }
      },
      "seq": 297,
      "void": false
    },
    {
      "from": null,
      "id": 302,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.paymentStatue"
        },
        "id": {
          "type": "value",
          "value": "CardBillingPaymentArUX-div-302"
        }
      },
      "seq": 274,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "isMounted": false,
  "memo": false,
  "name": "CardBillingPaymentArUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "debug": true,
    "language": "EN",
    "showSupplyList": false
  },
  "width": 55
}

*********************************************************************************** */
